import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import useLocales from '../../../hooks/useLocales';
import { LANGUAGE } from '../../../constants';
import type { OptionsType } from '../../../types/options';

interface SelectCustomersProps {
  selectedCustomers: OptionsType[];
  options: OptionsType[];
  onChangeCustomer: (options: OptionsType[]) => void;
}

const SelectCustomers = React.memo(({ selectedCustomers, options, onChangeCustomer }: SelectCustomersProps): React.ReactElement => {
  const { t } = useTranslation();
  const { currentLang } = useLocales();

  /**
   * プルダウン選択肢のラベル表示関数
   * @param option[OptionsType] 選ばれた選択肢オブジェクト
   * @returns string ラベル文字列
   */
  const getOptionLabel = (option: OptionsType): string => (currentLang.value === LANGUAGE.JA ? option.nameJapanese : option.nameEnglish ?? option.nameJapanese);

  /**
   * プルダウン選択肢のラベル表示関数
   * @param option[OptionsType] 選ばれた選択肢オブジェクト
   * @returns string ラベル文字列
   */
  const getOptionValue = (option: OptionsType): string => option.code;

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <Select
      id="selectIncludedCustomers"
      isMulti={true}
      value={selectedCustomers}
      options={options}
      onChange={onChangeCustomer}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      placeholder={t('user.emailRefinementMessage')}
      className="react-select-container"
      classNamePrefix="react-select"
    />
  );
});

SelectCustomers.displayName = 'SelectCustomers';
export default SelectCustomers;
